import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import { React } from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 36,
  height: 20,
  padding: 0,
  margin: 0,
  '& .MuiSwitch-switchBase': {
    padding: 1,
    margin: 1,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#054E8B',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
      '& .css-j204z7-MuiFormControlLabel-root ': {
        margin: 0,
      },
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 16,
    height: 16,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#054E8B',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const CustomizedSwitch = (props) => {
  const toggleSwitch = () => {
    if (props.toggleSwitch) {
      props.toggleSwitch();
    }
  };
  return (
    <FormGroup>
      <FormControlLabel
        sx={{ mx: '0px' }}
        control={
          <IOSSwitch
            sx={{ my: 1 }}
            checked={props.enabled}
            onChange={toggleSwitch}
          />
        }
      />
    </FormGroup>
  );
};
CustomizedSwitch.propTypes = {
  enabled: PropTypes.bool.isRequired,
  toggleSwitch: PropTypes.func.isRequired,
};
export default CustomizedSwitch;
